import { Component, OnInit, ViewChild } from '@angular/core';
import { SuperComponent } from '../../super/super.component';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-employee-attachment-type',
  templateUrl: './employee-attachment-type.component.html',
  styleUrls: ['./employee-attachment-type.component.scss']
})
export class EmployeeAttachmentTypeComponent extends SuperComponent implements OnInit {
  allEmployeeAttachmentType:any =[]
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(Objects: ObjectsService, translate: TranslateService, private publicSetting: publicSettingService, private NotifyService: NotifyService, private validation: CheckValidation, gt: genericCustomStoreService) {
    super(Objects, translate, gt)
    this.validateAsyncForAr = this.validateAsyncForAr.bind(this);
    this.validateAsyncForEn = this.validateAsyncForEn.bind(this);

  }
  validateAsyncForAr(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "EmployeeAttachmentTypes", "CheckName", "NameAr");
  }
  validateAsyncForEn(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "EmployeeAttachmentTypes", "CheckName", "NameEn");
  }
  ngOnInit(): void {
    this.getAllEmployeeAttachmentType();
  }
  getAllEmployeeAttachmentType() {
    this.gt.seturl("EmployeeAttachmentTypes");
    this.gt.submit();
    this.allEmployeeAttachmentType = this.gt.customDataSource;
    console.log("this.this.allEmployeeAttachmentType", this.allEmployeeAttachmentType)
  }


  onEditingStart(e: any) {
    this.addpopup = this.translate.instant('hr.EmployeeAttachmentTypes');
  }


}
